import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Form from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'

import { opacityReveal } from './animations/opacity'

export type ContactFormProps = HTMLAttributes<HTMLElement> &
  Partial<{
    className: string
    form: {
      id: number
      button: {
        text: string
      }
      fields: any[]
    }
  }>

const ContactForm = ({ className, form, ...props }: ContactFormProps) => {
  return (
    <Motion animation={opacityReveal}>
      <section className={className} {...props}>
        <Container data-motion-block>
          <Grid>
            <div className="col-span-4 md:col-span-6 lg:col-span-8 lg:col-start-3">
              <Form
                form_id={form?.id}
                fields={form?.fields}
                submit={form?.button.text}
              />
            </div>
          </Grid>
        </Container>
      </section>
    </Motion>
  )
}

export default ContactForm
